'use strict';

function introRouting($stateProvider) {

    let introBaseState = 'root.help';

    $stateProvider

    /**
     * WITHOUT END-POINT Section - Help
     */
        .state('' + introBaseState + '', {
            abstract: true,
            url: "/help",
            views: {
                '': {
                    template: "<ui-view/>",
                    //controller: "HelpController"
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-help-side-menu></section-help-side-menu></nav>'
                }
            },
            resolve: {
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./help.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
            },
            data: {
                baseState: introBaseState,
                requiresLogin: true,
                pageTitle: 'Help',
                showSideMenu: true
            }
        })

        .state('' + introBaseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {
                pageTitle: 'Help'
            }
        })

        .state('' + introBaseState + '.introduction', {
            url: "/introduction",
            template: require("./introduction.html"),
            data: {
                pageTitle: 'Help'
            }
        })

    ;

};

function routing($stateProvider) {

    let baseState = 'root.api-endpoints.existing.help';

    $stateProvider

    /**
     * Section - Help
     */
        .state('' + baseState + '', {
            abstract: true,
            url: "/help",
            views: {
                '': {
                    template: "<ui-view/>",
                    //controller: "GetStartedController"
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-help-side-menu></section-help-side-menu></nav>'
                }
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {

                },
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./help.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
            },
            data: {
                pageTitle: 'Help',
                showSideMenu: true
            }
        })

        .state('root.api-endpoints.existing.help.overview', {
            url: "/help",
            template: require("./overview.html"),
            data: {
                pageTitle: 'Help'
            }
        })

        .state('root.api-endpoints.existing.help.introduction', {
            url: "/introduction",
            template: require("./introduction.html"),
            data: {
                pageTitle: 'Help'
            }
        })

    ;
}

export default angular
    .module('help.routing', [])
    .config(function ($stateProvider) {

        // Lazy load the states instead of loading them all at app bootstrap

        /*
         let lazyIntroStateProvider = {
         states: [],
         state: function (name, stateConfig) {
         let state = angular.merge({name: name}, stateConfig);
         this.states.push(state);
         return this;
         }
         };
         introRouting(lazyIntroStateProvider);
         $stateProvider.state('root.help.**', {
         url: "/help",
         lazyLoad: function ($transition$, ParentService) {
         return lazyIntroStateProvider;
         },
         });
         */
        // Eager-loading intro-states since there are issues with those routes and since they are so few, it is ok to load them eagerly for now
        introRouting($stateProvider);

        let lazyStateProvider = {
            states: [],
            state: function (name, stateConfig) {
                let state = angular.merge({name: name}, stateConfig);
                this.states.push(state);
                return this;
            }
        };
        routing(lazyStateProvider);
        $stateProvider.state('root.api-endpoints.existing.help.**', {
            url: "/help",
            lazyLoad: function ($transition$, ParentService) {
                return lazyStateProvider;
            },
        });

    });



// WEBPACK FOOTER //
// .-dna/app/sections/help/help.routing.js